import { isArray } from 'lodash';
import at from 'constants/ActionTypes/MeshBot';
import { updateTriggerBlockTree } from 'helpers/LocalMeshBot';

/**
 * Redux thunk action to update a trigger block inside a local MeshBot rule.
 *
 * This function retrieves the current `when` blocks from the selected local MeshBot rule,
 * updates a specific block using the provided `createOrUpdateBlockFn`, and dispatches the updated tree.
 *
 * @param {string} groupId - The ID of the group in the trigger tree where the update should happen.
 * @param {string} triggerId - The ID of the specific trigger to update or create.
 * @param {(prevBlock: Object | undefined) => Object} createOrUpdateBlockFn - A function that receives the current block (or undefined) and returns the new or updated block.
 * @returns {(dispatch: Function, getState: Function) => void} - A thunk function compatible with Redux Thunk middleware.
 */
export const updateLocalMeshBotTriggerField = (groupId, triggerId, createOrUpdateBlockFn) => (dispatch, getState) => {
    const state = getState();
    const selectedRuleWhen = state?.meshBot?.local?.selectedRule?.when;
    if (!isArray(selectedRuleWhen)) {
        return;
    }

    dispatch({
        type: at.UPDATE_LOCAL_SELECTED_RULE_WHEN_BLOCK,
        payload: updateTriggerBlockTree(selectedRuleWhen, groupId, triggerId, createOrUpdateBlockFn),
    });
};
